// ---------------------------------------------------------------------------
// System Email Template Builder Page — Wrapper for shared EmailTemplateBuilderPage
// ---------------------------------------------------------------------------

import { useParams, useNavigate } from 'react-router-dom';
import { useBreadcrumbs } from '../../contexts/BreadcrumbContext';
import { EmailTemplateBuilderPage } from '@firesquirrel/ui-admin';
import {
  getEmailTemplate,
  createEmailTemplate,
  updateEmailTemplate,
} from '../../services/systemEmailTemplateService';

export default function SystemEmailTemplateBuilderPage() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { setBreadcrumbLabel } = useBreadcrumbs();
  const isNew = !id || id === 'new';

  return (
    <EmailTemplateBuilderPage
      id={id}
      isNew={isNew}
      backPath="/document-templates"
      getEmailTemplate={getEmailTemplate}
      createEmailTemplate={createEmailTemplate}
      updateEmailTemplate={updateEmailTemplate}
      onNavigate={(path, options) => navigate(path, options)}
      setBreadcrumbLabel={setBreadcrumbLabel}
      currentUser="system-admin"
    />
  );
}
